// import { DELETE } from '../../actions/bin';

export const del = {
  title: 'Delete',
  shortcut: 'command+shift+backspace',
  run: dispatch => {
    alert('Not implemented yet');
    return;
    // if (
    //   window.confirm('Are you sure you want to permanently delete this bin?')
    // ) {
    //   dispatch({ type: DELETE });
    // }
  },
};



// WEBPACK FOOTER //
// ./src/lib/commands/del.js